import React from 'react';

const BaseIcon = ({ children, size = 24, className = '', ...props }) => {
    const id = React.useId();
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
            {...props}
        >
            <defs>
                <linearGradient id={`grad-${id}`} x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="currentColor" stopOpacity="1" />
                    <stop offset="100%" stopColor="currentColor" stopOpacity="0.7" />
                </linearGradient>
            </defs>
            <g stroke={`url(#grad-${id})`}>
                {children}
            </g>
        </svg>
    );
};

export const AITutorIcon = (props) => (
    <BaseIcon {...props}>
        <rect x="3" y="11" width="18" height="10" rx="2" />
        <circle cx="12" cy="5" r="2" />
        <path d="M12 7v4" />
        <line x1="8" y1="15" x2="8" y2="15.01" />
        <line x1="16" y1="15" x2="16" y2="15.01" />
        {/* Inner detail: Sparkle notch */}
        <circle cx="12" cy="16" r="1" fill="currentColor" />
    </BaseIcon>
);

export const QuizzesIcon = (props) => (
    <BaseIcon {...props}>
        <path d="M9.5 2A5 5 0 0 1 12 11.5 5 5 0 0 1 14.5 2" />
        <path d="M12 12v3" />
        <path d="M12 19v.01" />
        <path d="M16 19h6" />
        <path d="M2 19h6" />
        {/* Inner detail: Floating dot */}
        <circle cx="12" cy="7" r="1.5" fill="currentColor" />
    </BaseIcon>
);

export const LessonsIcon = (props) => (
    <BaseIcon {...props}>
        <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" />
        <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
        {/* Inner detail: Book fold line */}
        <line x1="12" y1="7" x2="12" y2="18" strokeWidth="2" opacity="0.5" />
    </BaseIcon>
);

export const FinalQuizIcon = (props) => (
    <BaseIcon {...props}>
        <path d="M22 10v6M2 10l10-5 10 5-10 5z" />
        <path d="M6 12v5c0 2 2.7 3 6 3s6-1 6-3v-5" />
        {/* Inner detail: Tassel knot */}
        <circle cx="22" cy="16" r="1.5" fill="currentColor" />
    </BaseIcon>
);

export const ParentIcon = (props) => (
    <BaseIcon {...props}>
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
        <circle cx="12" cy="13" r="3" />
        {/* Inner detail: Heart center */}
        <path d="M12 11.5v3" strokeWidth="1.5" opacity="0.8" />
    </BaseIcon>
);

export const ProgressIcon = (props) => (
    <BaseIcon {...props}>
        <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" />
        <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" />
        <path d="M6 4h12v11c0 3-2 6-6 6s-6-3-6-6z" />
        {/* Inner detail: Star notch on trophy */}
        <circle cx="12" cy="10" r="2" fill="currentColor" />
    </BaseIcon>
);

export const BrandedIcons = {
    ai: AITutorIcon,
    quizzes: QuizzesIcon,
    lessons: LessonsIcon,
    finalQuiz: FinalQuizIcon,
    parent: ParentIcon,
    progress: ProgressIcon,
};
